module.exports = __webpack_public_path__ + "img/bronze.d01572c9.svg";